import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// REMOVED: import { getStorage } from "firebase/storage"; <--- Not needed for Cloudinary

const firebaseConfig = {
  apiKey: "AIzaSyC-wYVrQ-KfSVbNz4rRjiX-UVjdsgmP4kw",
  authDomain: "korabou25.firebaseapp.com",
  projectId: "korabou25",
  storageBucket: "korabou25.firebasestorage.app",
  messagingSenderId: "912788647050",
  appId: "1:912788647050:web:d2c1058a27a01c06ffd173"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export only Firestore (Database)
export const db = getFirestore(app);

// REMOVED: export const storage = getStorage(app); <--- Not needed anymore